/** Trace ID of the latest `GET /api/user`, taken from its RUM resource event. */
let latestUserRequestTraceId: string | undefined;

function isUserRequest(method: string, url: string): boolean {
  if (method.toUpperCase() !== 'GET') {
    return false;
  }
  try {
    return new URL(url, 'http://localhost').pathname.replace(/\/+$/, '') === '/api/user';
  } catch {
    return false;
  }
}

/**
 * Called with each traced resource event (before its URL is scrubbed). Keeps the ID of the most
 * recent `GET /api/user`, for pages that show a reference ID. The event is emitted when the
 * request completes, so a page reading it right after the response may still see the previous ID.
 */
export function rememberUserRequestTraceId(method: string, url: string, traceId: string | undefined): void {
  if (traceId && isUserRequest(method, url)) {
    latestUserRequestTraceId = traceId;
  }
}

/** The Datadog trace ID of the most recent `GET /api/user`, for pages that show a reference ID. */
export function getLatestUserRequestTraceId(): string | undefined {
  return latestUserRequestTraceId;
}

/** For specs. */
export function clearRequestTraceIds(): void {
  latestUserRequestTraceId = undefined;
}
